import { render, staticRenderFns } from "./informazioni.vue?vue&type=template&id=df129844&"
import script from "./informazioni.vue.ts?vue&type=script&lang=ts&"
export * from "./informazioni.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports